import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/neos': {
    width: 456,
    height: 512,
    paths: [
      {
        d: 'M387.4 512H292.3L184.1 357.5V448.6L97.7 512H0V29.8L40.5 0H148.5L272.3 176.1V63.4L358.7 0H456.4V461.5L387.4 512zM10.8 35.3V496L82.8 443.1V193.9L298.3 501.6H383.1L435.4 463.5H357.1L41 13 10.8 35.3zM93.3 501.9L173.3 443.1V342.1L93.5 227.7V448.6L21 501.9H93.3zM52.6 10.8L363.2 453.3H445.6V10.8H365.9V328.3L142.9 10.8H52.6zM283 191.6L355 294.5V15.9L283 68.9V191.6z'
      }
    ]
  }
})
